module.exports = __webpack_public_path__ + "static/media/turkey.4135609b.jpg";